import {InfoPage, RsnButton, RsnTextButton} from '@raison/ui-kit';
import React, {Fragment, PropsWithChildren} from 'react';
import {useGoHome, useGoToSupport} from '../../model/SendTxRouting';
import {InfoDialogLayout} from '../layouts/InfoDialogLayout';

export function Disclosure({open, children}: PropsWithChildren<{open: boolean; className?: string}>) {
    if (!open) {
        children = null;
    }
    return <Fragment>{children}</Fragment>;
}

export function WalletVASPInfoDialog() {
    const texts = {
        Title: 'Wallet VASP',
        Details:
            'A Virtual Asset Service Provider (VASP) is an entity or business that facilitates activities involving virtual assets, such as cryptocurrency transactions. VASPs include cryptocurrency exchanges, wallet providers, and other entities offering services like trading, transferring, or safekeeping digital assets.',
        IGotIt: 'I got it',
    };
    return <InfoDialogLayout title={texts.Title}>{texts.Details}</InfoDialogLayout>;
}

export function TxFeeInfoDialog() {
    const t = {
        Title: 'Transaction fee',
        Details:
            'A transaction fee in cryptocurrency is a small payment you make to process your transaction. You choose its priority, and the higher the priority, the higher the fee. A higher fee ensures your transaction is processed faster.',
    };
    return <InfoDialogLayout title={t.Title}>{t.Details}</InfoDialogLayout>;
}

export function TransactionSentForReview() {
    const t = {
        Continue: 'Continue',
        Heading: 'The transaction data has been sent for review',
        Details: 'The transaction will be ready for execution after verifying the specified data.',
    };
    return (
        <InfoPage.Layout symbol='time'>
            {{
                center: <InfoPage.Center heading={t.Heading} details={t.Details} />,
                footer: <RsnButton.Primary onClick={useGoHome({replace: true})}>{t.Continue}</RsnButton.Primary>,
            }}
        </InfoPage.Layout>
    );
}

export function EmailSentToThirdParty({beneficiaryEmail}: {beneficiaryEmail: string}) {
    const t = {
        Continue: 'Continue',
        Heading: 'Email has been sent',
        Details: `Tell the beneficiary to follow the link in the verification email that we sent to ${beneficiaryEmail}. If it doesn’t arrive, let him check the spam folder.`,
    };
    return (
        <InfoPage.Layout symbol='email'>
            {{
                center: <InfoPage.Center heading={t.Heading} details={t.Details} />,
                footer: <RsnButton.Primary onClick={useGoHome({replace: true})}>{t.Continue}</RsnButton.Primary>,
            }}
        </InfoPage.Layout>
    );
}

export function EmailSentToSelf({beneficiaryEmail}: {beneficiaryEmail: string}) {
    const t = {
        Continue: 'Continue',
        Heading: 'Check your email',
        Details: `Please follow the link in the verification email that we sent to ${beneficiaryEmail}. If it doesn’t arrive, check your spam folder.`,
        DidNotReceiveEmail: 'I didn’t receive the email',
    };
    return (
        <InfoPage.Layout symbol='email'>
            {{
                center: (
                    <InfoPage.Center heading={t.Heading} details={t.Details}>
                        <RsnTextButton.Block onClick={useGoToSupport()}>{t.DidNotReceiveEmail}</RsnTextButton.Block>
                    </InfoPage.Center>
                ),
                footer: <RsnButton.Primary onClick={useGoHome({replace: true})}>{t.Continue}</RsnButton.Primary>,
            }}
        </InfoPage.Layout>
    );
}

export function WalletTypeInfoDialog() {
    const texts = {
        Title: 'Wallet type',
        Details: 'A wallet type indicates how a cryptocurrency wallet is managed and operated.',
        VASP: 'VASP',
        VASPDescription:
            'Wallet connected to an exchange or financial service (like Binance, Coinbase, or any platform where you log in to manage your crypto).',
        Unhosted: 'Unhosted',
        UnhostedDescription:
            'Wallet that is a personal wallet app (like a mobile wallet or hardware wallet) that you or the beneficiary control directly.',
        IGotIt: 'I got it',
    };

    return (
        <InfoDialogLayout title={texts.Title}>
            <p className='fv-text-l-regular text-neutral-90'>{texts.Details}</p>
            <section className='fv-text-m-regular rounded-md bg-neutral-20 p-5 text-left text-neutral-90'>
                <h4 className='fv-text-l-bold mb-2 text-neutral-100'>{texts.VASP}</h4>
                <p>{texts.VASPDescription}</p>
                <hr className='my-4 border-t border-solid border-neutral-40' />
                <h4 className='fv-text-l-bold mb-2 text-neutral-100'>{texts.Unhosted}</h4>
                <p>{texts.UnhostedDescription}</p>
            </section>
        </InfoDialogLayout>
    );
}

export function CompanyIdInfoDialog() {
    const texts = {
        Title: 'CRN',
        Details:
            'A Company Registration Number (CRN) is a unique code given to a business when it registers with a national authority. It proves the company’s legal status and is used in official documents within its country.',
        IGotIt: 'I got it',
    };

    return (
        <InfoDialogLayout title={texts.Title}>
            <p className='fv-text-l-regular text-neutral-90'>{texts.Details}</p>
        </InfoDialogLayout>
    );
}
